export default __webpack_public_path__ + "static/media/five_tou3.21906069.png";